module.exports = __webpack_public_path__ + "img/backhoe_loader.da95ec19.jpg";